import { updateVariationsErrors } from '@/utils/validations/variations';
import { shapeVariationsForApp } from '@/utils/variations/shapeForApp';
import { isProfileOperation } from '@/utils/variations/operations';
import { replaceOperation } from '@/utils/product/operations';
import { editVariations } from '@/utils/edit/variations';
import { retain } from '@/utils/variations/retain';
import { get } from '@/utils/iterable/get';

import { EBAY, ETSY, FAIRE, SHOPIFY } from '@/constants/channels';
import { ATTRIBUTE } from '@/constants/attributes';
import { VALUE } from '@/constants/product';
import { EMPTY } from '@/constants';
import { FORM } from '@/constants/forms';
import { DATA } from '@/data';

export function variations({ operation, product, ...rest }) {
  const channel = product.get('channel');

  switch (channel) {
    case EBAY: {
      const { shop, shopData } = rest;
      const marketplaceId = shop.get('marketplaceId');
      const category = product.getIn([FORM.DETAILS, ATTRIBUTE.ITEM_CATEGORY, VALUE]);

      if (get([EBAY, marketplaceId, 'CATEGORIES', category, 'features', 'variations'])(DATA) === false) {
        return { product, ...rest };
      }

      const itemSpecifics = product.getIn([FORM.DETAILS, ATTRIBUTE.ITEM_SPECIFICS], EMPTY.MAP);
      const asProfile = isProfileOperation({ channel, operation });
      let result = shapeVariationsForApp({ asProfile, data: operation.get(VALUE), product });

      if (asProfile) {
        result = retain({ channel, product, shopData, variations: result, validate: false });
      }

      const updates = editVariations({
        product,
        shop,
        shopData,
        value: updateVariationsErrors({ category, channel, itemSpecifics, shop, shopData, variations: result }),
      });

      return {
        ...rest,
        product: updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case ETSY: {
      if (product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE])) {
        return { product, ...rest };
      }

      const { shop, shopData } = rest;
      const asProfile = isProfileOperation({ channel, operation });
      let result = shapeVariationsForApp({ asProfile, data: operation.get(VALUE), product });

      if (asProfile) {
        result = retain({ channel, product, shopData, variations: result, validate: false });
      }

      const updates = editVariations({
        product,
        shop,
        shopData,
        value: updateVariationsErrors({ channel, shop, shopData, variations: result }),
      });

      return {
        ...rest,
        product: updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case FAIRE: {
      const { shop, shopData } = rest;
      const asProfile = isProfileOperation({ channel, operation });
      let result = shapeVariationsForApp({ asProfile, data: operation.get(VALUE), product });

      if (asProfile) {
        result = retain({ channel, product, shopData, variations: result, validate: false });
      }

      const updates = editVariations({
        product,
        shop,
        shopData,
        value: updateVariationsErrors({ channel, shop, shopData, variations: result }),
      });

      return {
        ...rest,
        product: updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case SHOPIFY: {
      const { shop, shopData } = rest;
      const asProfile = isProfileOperation({ channel, operation });
      let result = shapeVariationsForApp({ asProfile, data: operation.get(VALUE), product });

      if (asProfile) {
        result = retain({ channel, product, shopData, variations: result, validate: false });
      }

      const updates = editVariations({
        product,
        shop,
        shopData,
        value: updateVariationsErrors({ channel, shop, shopData, variations: result }),
      });

      return {
        ...rest,
        product: updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    default: {
      return { product, ...rest };
    }
  }
}
